import * as Icons from "lucide-react";
import { catStyle } from "@/lib/format";

export function CategoryIcon({ category, size = 44, iconSize = 20, className = "" }) {
  const s = catStyle(category);
  const Icon = Icons[s.icon] || Icons.Tag;
  return (
    <div
      className={`flex shrink-0 items-center justify-center rounded-2xl ${className}`}
      style={{ width: size, height: size, background: `${s.color}22`, color: s.color }}
      aria-hidden="true"
    >
      <Icon size={iconSize} strokeWidth={2.2} />
    </div>
  );
}

export function CategoryBadge({ category }) {
  const s = catStyle(category);
  return (
    <span className="rounded-full px-2.5 py-0.5 text-[11px] font-semibold" style={{ background: `${s.color}22`, color: s.color }} data-testid="memory-category-badge">
      {category}
    </span>
  );
}
